<div class="unauthorized-view">
  <img
    class="unauthorized-view__img"
    src="assets/file-browser/401.png"
    alt="Unauthorized"
  />
  <p class="unauthorized-view__text">
    {{ 'FILE_BROWSER.UNAUTHORIZED_VIEW_MESSAGE' | translate }}
    <br> {{ 'FILE_BROWSER.UNAUTHORIZED_VIEW_MESSAGE_RENEW' | translate }}
  </p>
</div>
